var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "#B1B1B1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2254,
    transform: "translate(-631 -963)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 2",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -481,
    y: -132,
    width: 1620,
    height: 421.551,
    rx: 27.0225,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.6621 23.1456C29.2021 22.8929 28.6246 23.061 28.3721 23.5208C28.1194 23.9806 28.2874 24.5582 28.7473 24.8108C29.8789 25.4325 30.528 26.1217 30.528 26.7017C30.528 27.4111 29.5229 28.5106 26.7018 29.469C23.9148 30.416 20.1903 30.9374 16.2145 30.9374C12.2387 30.9374 8.51421 30.416 5.7272 29.469C2.90611 28.5107 1.901 27.4111 1.901 26.7017C1.901 26.1217 2.55004 25.4325 3.6817 24.8107C4.14157 24.5582 4.30953 23.9806 4.05689 23.5207C3.80425 23.0609 3.22683 22.8929 2.76684 23.1455C1.5051 23.8387 0.000976562 25.0184 0.000976562 26.7017C0.000976562 27.9921 0.888413 29.8318 5.11596 31.2681C8.09469 32.2801 12.0362 32.8374 16.2145 32.8374C20.3928 32.8374 24.3343 32.2801 27.313 31.2681C31.5406 29.8318 32.428 27.9921 32.428 26.7017C32.428 25.0184 30.9239 23.8387 29.6621 23.1456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.04105 28.0957C10.9696 28.6405 13.5168 28.9405 16.2135 28.9405C18.9102 28.9405 21.4574 28.6405 23.386 28.0957C25.7453 27.4292 26.9417 26.4644 26.9417 25.2282C26.9417 23.992 25.7453 23.0273 23.386 22.3608C22.8622 22.2129 22.2926 22.0831 21.687 21.9724C21.3581 22.5406 21.0135 23.1255 20.6532 23.7273C21.3235 23.8278 21.9528 23.9512 22.5244 24.0968C24.2607 24.539 24.8951 25.0369 25.0255 25.2283C24.895 25.4197 24.2608 25.9176 22.5244 26.3598C20.881 26.7784 18.7665 27.0172 16.5395 27.0385C16.4316 27.0465 16.3229 27.051 16.2135 27.051C16.104 27.051 15.9954 27.0465 15.8875 27.0385C13.6604 27.0172 11.546 26.7785 9.90252 26.3598C8.16615 25.9176 7.53186 25.4197 7.40146 25.2283C7.53186 25.0369 8.16622 24.539 9.90258 24.0968C10.4741 23.9512 11.1035 23.8278 11.7739 23.7273C11.4135 23.1256 11.0689 22.5406 10.74 21.9724C10.1344 22.0832 9.56476 22.2129 9.04105 22.3608C6.68167 23.0273 5.48535 23.9921 5.48535 25.2282C5.48535 26.4644 6.68167 27.4291 9.04105 28.0957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.2141 25.1508C17.0598 25.1508 17.828 24.7199 18.2692 23.9981C21.3605 18.9404 25.0454 12.2748 25.0454 9.24163C25.0454 4.37207 21.0837 0.4104 16.2141 0.4104C11.3445 0.4104 7.38281 4.37207 7.38281 9.24163C7.38281 12.2748 11.0678 18.9404 14.159 23.9981C14.6002 24.7199 15.3685 25.1508 16.2141 25.1508ZM12.6644 8.63527C12.6644 6.67806 14.2568 5.08572 16.2141 5.08572C18.1714 5.08572 19.7638 6.67806 19.7638 8.63527C19.7638 10.5925 18.1714 12.1849 16.2141 12.1849C14.2568 12.1849 12.6644 10.5926 12.6644 8.63527Z",
    fill: "black"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -491.809,
    y: -142.809,
    width: 1647.02,
    height: 448.574,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.70225,
    dy: 2.70225
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.75563
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.427,
    height: 32.427,
    fill: "white",
    transform: "translate(0.000976562 0.4104)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1caa6ea0a8b2293956836776e3507f20.svg";
export { ForwardRef as ReactComponent };